import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function GlobalBackButton({ compact = false }) {
  const location = useLocation();
  const navigate = useNavigate();
  // Only go back through entries created since entering this app layout.
  // A direct link or refresh falls back to Home, never an external page/login.
  const entryIndex = useRef(window.history.state?.idx ?? 0);
  const canGoBack = (window.history.state?.idx ?? 0) > entryIndex.current;
  const isHome = location.pathname.replace(/\/$/, "") === "/app" && !location.search && !location.hash;

  if (isHome && !canGoBack) return null;
  const go = () => canGoBack ? navigate(-1) : navigate("/app", { replace: true });

  if (compact) return (
    <button type="button" onClick={go} aria-label={canGoBack ? "Go back" : "Back to home"} data-testid="global-back-button" className="fl-backpill">
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      Back
    </button>
  );

  return (
    <div className="px-4 lg:px-5 border-b border-zinc-200 dark:border-white/[0.07] bg-card">
      <button
        type="button"
        onClick={go}
        aria-label={canGoBack ? "Go back" : "Back to home"}
        data-testid="global-back-button"
        className="inline-flex min-h-11 items-center gap-2 rounded-md px-2 text-sm font-medium text-zinc-600 hover:text-[#FF5F15] dark:text-zinc-300 dark:hover:text-[#FF5F15] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5F15]"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Back
      </button>
    </div>
  );
}
